import { PickupEventListPage } from "components/shared/pickupEvents";

export const PAGE_SIZE = 10;

const WPSCheckinEventsListPage = () => (
  <PickupEventListPage variant="wps" />
);

export default WPSCheckinEventsListPage;
